import { render, staticRenderFns } from "./medication-selector-response.vue?vue&type=template&id=3633d418&scoped=true&"
import script from "./medication-selector-response.vue?vue&type=script&lang=js&"
export * from "./medication-selector-response.vue?vue&type=script&lang=js&"
import style0 from "./medication-selector-response.vue?vue&type=style&index=0&id=3633d418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633d418",
  null
  
)

component.options.__file = "medication-selector-response.vue"
export default component.exports